export enum CurrencyFormatEnum {
  WIDE = 'wide',
  NARROW = 'narrow',
}

export type CurrencyFormat = 'wide' | 'narrow';
